import { ThemeProvider as LazyComponentsThemeProvider, Theme } from 'jpi-cloud-web-ui-kit';
import React, { ReactNode, Suspense } from 'react';
import { ThemeProvider as AppThemeProvider } from 'styled-components';

import defaultTheme from '@jpi-cloud-web-pro/jpi-cloud-shared/components/SharedThemeWrapper/theme';
import * as themes from '@jpi-cloud-web-pro/jpi-cloud-shared/components/SharedThemeWrapper/themes';

import { DEFAULT_BRAND } from '@jpi-cloud-web-pro/jpi-cloud-shared/config/common';

const brandThemeMap = {
  myuplink: defaultTheme,
  ...themes,
};

interface ThemeWrapperProps {
  children: ReactNode;
  brandId?: string;
}

const ThemeWrapper = ({ children, brandId = DEFAULT_BRAND }: ThemeWrapperProps) => {
  const theme: Theme = brandThemeMap[brandId] || defaultTheme;

  return (
    <AppThemeProvider theme={theme}>
      <Suspense fallback={null}>
        <LazyComponentsThemeProvider theme={theme}>{children}</LazyComponentsThemeProvider>
      </Suspense>
    </AppThemeProvider>
  );
};

export default ThemeWrapper;
